module.exports = __webpack_public_path__ + "img/397-f50ade.png";